import { AdvertiserModel } from '@/models/Advertiser'

const mutations = {
  INITIALIZE(state, { advertiser }) {
    state.currentAdvertiser = new AdvertiserModel(advertiser)
  },
}

export default mutations
